import { InternationalisationService } from "../../forked/angular-internationalisation";
import Utils from "../utils";
import { DataModel, SyncModel, SyncDataModel } from "./syncModel";
import * as moment from "moment";
import { ContentType, ImageOrientation } from "../contentTypes";

export class ServiceCallSyncModel extends SyncModel {
}

export class ServiceCallDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;
  /** eintrag gelöscht, nicht nutzen */
  public deleted: boolean;
  /** ServiceCall knopf soll angeboten */
  public enabled: boolean;
  /** sortier reihenfolge */
  public sort_number: number;
/** geändert durch */
  public change_by: number;
  public change_at_ymd: number;
  public change_at_hms: number;
  /** geändert am */
  public get change_at(): moment.Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
  public label_de: string;
  public label_en: string;
  /** Bezeichnung */
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public description_de: string;
  public description_en: string;
  /** Beschreibung */
  public get description(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.description_en) ? this.description_de : this.description_en;
  }
  /** möglich URL, falls der Gast umgeleitet werden soll */
  public url: string;
  /** test der ans POS beim ServiceCall versendet wird */
  public pos_message: string;
  public last_image_update_at_ymd: number;
  public last_image_update_at_hms: number;
  /** letzter änderungstermin vol bild */
  public get last_image_update_at(): moment.Moment {
    return Utils.GetMomentFromInt(this.last_image_update_at_ymd, this.last_image_update_at_hms);
  }
  /** url zum bild, vorprüfung last_image_update_at_ymd > 0 notwendig  */
  public get image_photo(): string {
    return ContentType.Inhouse_ServiceCalls + "/" + this.id + "_photo_" + ImageOrientation.Landscape + "/" + this.last_image_update_at_ymd + "/" + this.last_image_update_at_hms;
  }

  public DeserializeSubTypes(): void {
    // no complx types
  }
}

export class ServiceCallSyncDataModel extends SyncDataModel {
  public service_calls: ServiceCallDataModel[];
  public get models(): DataModel[] { return this.service_calls; }
  public DeserializeType(): void {
    this._DeserializeType(ServiceCallDataModel);
  }
}
